import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import ButtonCustom from '../../../common/components/ui/button/button';
import { useSelector } from "react-redux";
import * as actions from '../../../store/actions/index';
import { getSupplierProfile, updateSupplierProfile } from '../../../store/actions/admin';
import { connect } from 'react-redux';
import { sub } from 'date-fns';
import MaterialTable from 'material-table';
import { formatDate } from '../../../common/utils/utility';
import MenuItem from '@material-ui/core/MenuItem';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';

const SupplierProfile = (props) => {
    const subscriptionType = [
        "Base",
        "Insight Engine"
    ];
    const initialInfo = {
        id: '',
        netsuiteId: '',
        subscriptionType: '',
        subscriptionPrice: '',
        subscriptionStartDate: '',
        subscriptionEndDate: '',
        users: [],
    };
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const supplierList = useSelector((state) => state.suppliers.supplierList);
    const [supplierProfile, setSupplierProfile] = useState(initialInfo);
    const [isSupplierLoading, setIsSupplierLoading] = useState(true);
    const [isSupplierChanged, setIsSupplierChanged] = useState(false);

    const getSupplierProfileInfo = (supplierId) => {
        getSupplierProfile(supplierId).then(response => {
            setIsSupplierLoading(false);
            let responseData = response.data;
            responseData.subscriptionStartDate = cleanDate(responseData.subscriptionStartDate);
            responseData.subscriptionEndDate = cleanDate(responseData.subscriptionEndDate);
            setStartDate(responseData.subscriptionStartDate);
            setEndDate(responseData.subscriptionEndDate);

            setSupplierProfile(responseData);
        }).catch((err) => {
            const errMsg = 'Something went wrong';
        });
    };

    const cleanDate = (date) => {
        const defaultDateFromDB = '0001-01-01T00:00:00';
        let cleanDate = date;
        if (!date || date == defaultDateFromDB) {
            cleanDate = new Date();
        }
        return cleanDate;
    }

    const changeHandlerSupplierSelect = (event) => {
        setIsSupplierLoading(true);
        setIsSupplierChanged(false);
        getSupplierProfileInfo(event.target.value);
    }

    const changeHandlerSupplierInfo = id => (event) => {
        if (!isSupplierChanged) {
            setIsSupplierChanged(true);
        }
        setSupplierProfile({
            ...supplierProfile,
            [id]: event.target.value
        })
    }

    const changeHandlerStartDate = (date) => {
        setIsSupplierChanged(true);
        setStartDate(date);
    }

    const changeHandlerEndDate = (date) => {
        setIsSupplierChanged(true);
        setEndDate(date);
    }

    const supplierProfileSave = (event) => {
        if (event) event.preventDefault();

        const updatedData = {
            id: supplierProfile.id,
            netsuiteId: supplierProfile.netsuiteId,
            supplierName: supplierProfile.supplierName && String(supplierProfile.supplierName),
            subscriptionType: supplierProfile.subscriptionType && supplierProfile.subscriptionType,
            subscriptionPrice: supplierProfile.subscriptionPrice && String(supplierProfile.subscriptionPrice),
            subscriptionStartDate: startDate,
            subscriptionEndDate: endDate,
        };
        updateSupplierProfile(updatedData);
        setIsSupplierChanged(false);
    }

    const UserTable = () => {
        return (
            <React.Fragment>
                <MaterialTable
                    columns={[
                        { title: 'Name', field: 'fullName' },
                        { title: 'Email', field: 'email' },
                        { title: 'Active', field: 'isActive' }
                    ]}
                    data={supplierProfile.users}
                    onRowClick={(event, rowData) => { props.history.push('/admin/userManagementDetails/' + rowData.id, { rowData }) }}
                    options={{
                        filtering: false,
                        actionsColumnIndex: -1,
                        search: false,
                        paging: true,
                        toolbar: false,
                        pageSize: 10,
                        headerStyle: {
                            backgroundColor: 'gray',
                            color: '#FFF'
                        },
                    }}
                    localization={{ body: { emptyDataSourceMessage: "" } }}
                />
            </React.Fragment>
        );
    }

    const FormSupplierSelector = () => {
        return (
            <Col sm={12} lg={6}>
                <TextValidator
                    id="netsuiteId"
                    select
                    autoComplete="off"
                    label="Supplier"
                    variant="outlined"
                    value={supplierProfile.netsuiteId || ''}
                    onChange={changeHandlerSupplierSelect}
                >
                    {supplierList.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextValidator>
            </Col>
        );
    }

    const FormLoadingContainer = () => {
        return (
            <>
                {(supplierProfile.netsuiteId != '') && <div className="loadingContainer"></div>}
            </>
        );
    }

    const FormConditionalFields = () => {
        return (
            <>
                {(isSupplierLoading) ? FormLoadingContainer() :
                    <>
                        <Col sm={12} lg={6}>
                            <TextValidator
                                id="subscriptionType"
                                select
                                autoComplete="off"
                                label="Subscription Type"
                                variant="outlined"
                                value={supplierProfile.subscriptionType || ''}
                                onChange={changeHandlerSupplierInfo("subscriptionType")}
                            >
                                {subscriptionType.map((option, index) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextValidator>
                        </Col>
                        <Col sm={12} lg={6}>
                            <TextValidator
                                id="subscriptionPrice"
                                autoComplete="off"
                                label="Subscription Price"
                                variant="outlined"
                                value={supplierProfile.subscriptionPrice || ''}
                                onChange={changeHandlerSupplierInfo("subscriptionPrice")}
                            />
                        </Col>
                        <Col sm={12} lg={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    id="SubscriptionStartDate"
                                    required={false}
                                    disabled={false}
                                    format="M/dd/yyyy"
                                    label="Subscription Start Date"
                                    value={startDate}
                                    onChange={(date) => { changeHandlerStartDate(date) }}
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col sm={12} lg={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    id="SubscriptionEndDate"
                                    required={false}
                                    disabled={false}
                                    format="M/dd/yyyy"
                                    label="Subscription End Date"
                                    value={endDate}
                                    onChange={(date) => { changeHandlerEndDate(date) }}
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col sm={12} lg={6} style={{textAlign:"right"}}>
                            <ButtonCustom
                                hidden={!isSupplierChanged}
                                className='button primary'
                                variant="contained"
                                onClick={(eve) => { supplierProfileSave(eve) }}
                            >
                                Save
                            </ButtonCustom>
                        </Col>
                        <Col sm={12} lg={12}>
                            <Row>
                                <Col>
                                    <h3 className="section-header">Users</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {UserTable()}
                                </Col>
                            </Row>
                        </Col>
                    </>}
            </>
        );
    }

    return (
        <Container>
            <Row className="page-header-container">
                <Col>
                    <h2 className="page-header">Supplier Profile</h2>
                </Col>
            </Row>
            <Row className="page-content-container">
                <Col className="page-content-container-inner">
                    <ValidatorForm noValidate autoComplete="off" onSubmit={() => { }}>
                        {FormSupplierSelector()}
                        {FormConditionalFields()}
                    </ValidatorForm>
                </Col>
            </Row>
        </Container>
    );
}

export default connect(
)(SupplierProfile);
